import { CircularProgress } from '@mui/material';
import * as React from 'react';
import { memo, VFC } from 'react';
import { CSSBox } from '../../../CSSBox';

export interface MonacoLoadingProps {
  theme?: 'light' | 'dark';
}

export const MonacoLoading: VFC<MonacoLoadingProps> = memo(({ theme = 'light' }) => {
  const bgColor = theme === 'dark' ? '#1e1e1e' : '#fffffe';
  return (
    <CSSBox
      display="flex"
      background={bgColor}
      height="100%"
      width="100%"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress color="secondary" />
    </CSSBox>
  );
});
